module.exports = __webpack_public_path__ + "img/Ora-Ani_Felsen_kl.dd790e7b.jpg";